/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.RecommendationAppRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getInferenceHubTierRpc = {
  serviceName: 'com.hubspot.personalization.rpc.RecommendationAppRpc',
  rpcName: 'getInferenceHubTier',
  auth: 'app',
  fingerprint: '2Wn088hXPwOmascBpHKdw5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};